var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import useStateWithMutators from '@rad/hooks/useStateWithMutators';
import { useFetch, usePromise } from '@rad/hooks';
import { getConst } from '@rad/utility/http';
import { SITE_IS_AUTO, TEXT } from '../utility/constants';
import { postRawJson } from '../utility/request';
import { withToken, useScreen, navigate, fetchMerchantSubscription, clearSubscriptionCache } from '../utility/general';
import { fetchInvoice } from '../http/invoices';
import TemplateMain from './screens/templates/main';
import ScreenLogin from './screens/login';
import ScreenEUA from './screens/eua';
import ScreenDashboard from './screens/dashboard';
import ScreenSubscriptionKeys from './screens/subscription-keys';
import ScreenISOs from './screens/isos';
import ScreenISO from './screens/iso';
import ScreenMerchants from './screens/merchants';
import ScreenMerchant from './screens/merchant';
import ScreenConfiguration from './screens/configuration';
import ScreenUsers from './screens/users';
import ScreenAdminCRM from './screens/admin-crm';
import ScreenAdminBilling from './screens/admin-billing';
import ScreenClients from './screens/clients';
import ScreenClient from './screens/client';
import ScreenInvoices from './screens/invoices';
import ScreenInvoiceCreateEdit from './screens/invoice-create-edit';
import ScreenInvoiceView from './screens/invoice-view';
import ScreenReport from './screens/report';
import ScreenReports from './screens/reports';
import ScreenCardReports from './screens/card-reports';
import ScreenAppointments from './screens/appointments';
import ScreenServiceBays from './screens/service-bays';
import ScreenOnboarding from './screens/onboarding';
import ScreenSubscription from './screens/subscription';
import ScreenCRMHub from './screens/crm/hub';
import ScreenCRMConversations from './screens/crm/conversations';
import ScreenCRMScheduling from './screens/crm/scheduling';
import ScreenCRMEmailCampaigns from './screens/crm/email-campaigns';
import ScreenBillingStatement from './screens/billing-statement';
import ScreenInspectionPin from './screens/inspection-mode/pin';
import ScreenInspectionMyJobs from './screens/inspection-mode/my-jobs';
import ScreenInspectionNew from './screens/inspection-mode/new';
import ScreenInspectionSectionList from './screens/inspection-mode/section-list';
import ScreenInspectionSection from './screens/inspection-mode/section';
import ScreenInspectionReview from './screens/inspection-mode/review';
import ScreenInspectionView from './screens/inspection-view';
import { isKioskMode } from '../utility/kiosk';
import Button from './components/button';
import CModal from './components/modal';
// setInvoiceClassification('unknown')
// const [request,abort] = withAbort(fetchInvoice(
//   ,
// ))
// withDone(request)().then((x) => setInvoiceClassification(x.classification))
// return () => abort()
export default () => {
    const [token, setToken] = withToken();
    const screen = useScreen().split('?')[0];
    const inKiosk = isKioskMode();
    const [activePerformer, setActivePerformer] = React.useState(null);
    React.useEffect(() => {
        if (inKiosk && !screen.startsWith('#/inspection-mode')) {
            navigate('#/inspection-mode/pin');
        }
    }, [inKiosk, screen]);
    const [stateInvoiceId, setInvoiceId] = React.useState(null);
    const invoiceF = useFetch(stateInvoiceId === null ? getConst(undefined) : fetchInvoice(stateInvoiceId[0], stateInvoiceId[1]));
    const invoice = usePromise(invoiceF[0]);
    const invoiceClassification = stateInvoiceId === null ? null : invoice === undefined ? 'unknown' : invoice.classification_root;
    const [modals, modalsUpdate] = useStateWithMutators({
        'changes': {
            'href': null,
        },
    });
    const SCREEN_IS_HOME = ['', '#', '#/'].includes(screen);
    console.log(screen, SCREEN_IS_HOME);
    const euaAccepted = !!token && !!token.eua_accepted;
    const euaAccept = () => __awaiter(void 0, void 0, void 0, function* () {
        setToken((yield postRawJson(`/end-user-agreement/accept`, '')).token);
    });
    const navigateCheckSave = (e) => {
        console.log(e.currentTarget, e.currentTarget.href, sessionStorage.getItem('unsaved'));
        if (sessionStorage.getItem('unsaved')) {
            e.preventDefault();
            modalsUpdate.changes.href(e.currentTarget.href);
        }
    };
    const showDemoAccount = () => {
        // Implement demo account functionality
        // This could open a modal or navigate to demo account setup
    };
    React.useEffect(() => {
        if (screen.startsWith('#/onboarding') && !!token) {
            navigate('#/');
            return;
        }
        // Technician: locked to #/orders (list), #/invoices/{m}/{id} view of RO's
        // (server 403s non-order fetches), and #/service-bays. Digital Inspections
        // and kiosk-mode PIN flow are also allowed - techs are the primary users
        // of both. Everything else, including the merchant dashboard, redirects
        // to the RO list. /edit is a hard no - notes-add lives on the view screen.
        const isTechnician = !!(token === null || token === void 0 ? void 0 : token.merchant) && token.merchant.role === 'technician';
        if (isTechnician) {
            const allowedForTech = screen === '#/orders'
                || screen === '#/service-bays'
                || (screen.startsWith('#/invoices/') && !screen.endsWith('/edit') && !screen.startsWith('#/invoices/create'))
                || screen.startsWith('#/inspection-mode')
                || screen.startsWith('#/inspections/')
                || screen.startsWith('#/end-user-agreement')
                || screen.startsWith('#/subscription');
            if (!allowedForTech) {
                navigate('#/orders');
                return;
            }
        }
        const contextStr = typeof (token === null || token === void 0 ? void 0 : token.context) === 'string' ? token === null || token === void 0 ? void 0 : token.context : String(token === null || token === void 0 ? void 0 : token.context);
        if (contextStr.startsWith('merchant-')) {
            const merchantId = contextStr.substring('merchant-'.length);
            fetchMerchantSubscription(merchantId)
                .then((subscription) => {
                if (!subscription.has_subscription) {
                    navigate('#/subscription');
                }
            })
                .catch((err) => {
                console.error('Error checking subscription status:', err);
            });
        }
    }, [screen, token]);
    const login = (x) => {
        console.log(x);
        const tokenNew = setToken(x);
        // window.localStorage.setItem('token',json.token)
        // window.localStorage.setItem('token',json.token)
        if (tokenNew && tokenNew.context) {
            navigate('#/');
        }
        else {
            navigate('#/login/context');
        }
    };
    React.useEffect(() => {
        setInvoiceId(null);
        if (screen.startsWith('#/invoices/create')) {
            return;
        }
        if (screen.startsWith('#/invoices/')) {
            setInvoiceId([screen.substring('#/invoices/'.length).split('/')[0], screen.substring('#/invoices/'.length).split('/')[1]]);
        }
    }, [screen]);
    React.useEffect(() => {
        invoiceF[1]();
    }, [stateInvoiceId]);
    const pageTitle = (() => {
        const s = screen;
        if (SCREEN_IS_HOME)
            return 'Dashboard';
        if (s === '#/estimates')
            return 'Estimates';
        if (s === '#/invoices')
            return 'Invoices';
        if (s === '#/orders')
            return TEXT.ORDERS_TITLE;
        if (s.startsWith('#/invoices/create'))
            return 'New Estimate';
        if (s.startsWith('#/invoices/')) {
            const prefix = s.endsWith('/edit') ? 'Edit ' : '';
            switch (invoiceClassification) {
                case 'estimate':
                    return prefix + 'Estimate';
                case 'order':
                    return prefix + TEXT.ORDER_TITLE;
                case 'invoice':
                    return prefix + 'Invoice';
                default:
                    return prefix + 'Document';
            }
        }
        if (s === '#/appointments')
            return 'Appointments';
        if (s.startsWith('#/clients/'))
            return 'Client Details';
        if (s.startsWith('#/billing-accounts/'))
            return 'Account Statement';
        if (s === '#/clients')
            return 'Clients';
        if (s === '#/admin/configuration')
            return 'Configuration';
        if (s.startsWith('#/admin/isos/'))
            return 'ISO Details';
        if (s === '#/admin/isos')
            return 'ISOs';
        if (s.startsWith('#/admin/merchants/'))
            return 'Merchant Details';
        if (s === '#/admin/merchants')
            return 'Merchants';
        if (s === '#/admin/users')
            return 'Users';
        if (s === '#/admin/crm')
            return 'CRM Merchants';
        if (s === '#/admin/billing')
            return 'Merchant Billing';
        if (s === '#/admin/subscription-keys')
            return 'Subscription Keys';
        if (s === '#/reports' || s.startsWith('#/reports/'))
            return 'Reports';
        if (s.startsWith('#/end-user-agreement'))
            return 'End User Agreement';
        if (s.startsWith('#/onboarding'))
            return 'Onboarding';
        if (s.startsWith('#/subscription'))
            return 'Subscription';
        if (s === '#/crm')
            return 'CRM';
        if (s.startsWith('#/crm/conversations'))
            return 'Messages';
        if (s === '#/crm/scheduling')
            return 'Online Booking';
        if (s === '#/crm/email-campaigns')
            return 'Email Campaigns';
        if (s.startsWith('#/service-bays'))
            return 'Service Bays';
        return 'RateRemover';
    })();
    const content = !token ?
        () => _jsx("div", { style: { 'width': '100%' }, children: _jsx("h1", { className: "text-center", children: "Permission Denied" }) })
        : screen.startsWith('#/end-user-agreement') ?
            () => _jsx("div", { children: _jsx(ScreenEUA, {}) })
            /*
            #######################
            #########admin#########
            #######################
            */
            : screen == '#/admin/subscription-keys' ?
                () => _jsx(ScreenSubscriptionKeys, {})
                : screen == '#/admin/isos' ?
                    () => _jsx(ScreenISOs, {})
                    : screen.startsWith('#/admin/isos/') ?
                        () => _jsx(ScreenISO, { id: screen.substring('#/admin/isos/'.length) })
                        : screen == '#/admin/merchants' ?
                            () => _jsx(ScreenMerchants, {})
                            : screen.startsWith('#/admin/merchants/') ?
                                () => _jsx(ScreenMerchant, { id: screen.substring('#/admin/merchants/'.length) })
                                : screen == '#/admin/configuration' ?
                                    () => _jsx(ScreenConfiguration, {})
                                    : screen.startsWith('#/admin/configuration/') ?
                                        () => _jsx(ScreenConfiguration, { initialTab: screen.substring('#/admin/configuration/'.length) })
                                        : screen == '#/clients' ?
                                            () => _jsx(ScreenClients, {})
                                            : screen.startsWith('#/billing-accounts/') && screen.endsWith('/statement') && !!token.merchant ?
                                                () => _jsx(ScreenBillingStatement, { merchantId: token.merchant.id, clientId: screen.split('/')[2] })
                                                : screen.startsWith('#/clients/') ?
                                                    () => _jsx(ScreenClient, { clientId: screen.substring('#/clients/'.length) })
                                                    : screen === '#/appointments' ?
                                                        () => _jsx(ScreenAppointments, {})
                                                        : screen === '#/service-bays' && SITE_IS_AUTO && !!(token === null || token === void 0 ? void 0 : token.merchant) ?
                                                            () => _jsx(ScreenServiceBays, {})
                                                            : ['#/estimates', '#/orders', '#/invoices'].includes(screen) ?
                                                                () => _jsx(ScreenInvoices, { which: screen === '#/estimates' ? 'estimates' :
                                                                        screen === '#/orders' ? 'orders' :
                                                                            screen === '#/invoices' ? 'invoices' :
                                                                                'invoices' })
                                                                : screen.startsWith('#/invoices/create') || (screen.startsWith('#/invoices/') && screen.endsWith('/edit')) ?
                                                                    () => _jsx(ScreenInvoiceCreateEdit, { clientId: screen.startsWith('#/invoices/create/') ? screen.substring('#/invoices/create/'.length).split('/')[0] : undefined, merchantId: screen.endsWith('/edit') ? screen.substring('#/invoices/'.length).split('/')[0] : token.merchant.id, invoiceId: screen.endsWith('/edit') ? screen.substring('#/invoices/'.length).split('/')[1] : undefined })
                                                                    : screen.startsWith('#/invoices/') ?
                                                                        () => _jsx(ScreenInvoiceView, { merchantId: screen.substring('#/invoices/'.length).split('/')[0], invoice: invoiceF })
                                                                        : screen.startsWith('#/inspections/') ?
                                                                            () => _jsx(ScreenInspectionView, { id: screen.substring('#/inspections/'.length).split('/')[0] })
                                                                            : screen.startsWith('#/reports/card-reports') ?
                                                                                () => _jsx(ScreenCardReports, {})
                                                                                : screen === '#/reports' ?
                                                                                    () => _jsx(ScreenReports, {})
                                                                                    : screen.startsWith('#/reports/') ?
                                                                                        () => _jsx(ScreenReport, { report: screen.split('/')[2] })
                                                                                        : screen == '#/admin/users' ?
                                                                                            () => _jsx(ScreenUsers, {})
                                                                                            : screen == '#/admin/crm' ?
                                                                                                () => _jsx(ScreenAdminCRM, {})
                                                                                                : screen == '#/admin/billing' ?
                                                                                                    () => _jsx(ScreenAdminBilling, {})
                                                                                                    : screen.startsWith('#/subscription') ?
                                                                                                        () => _jsx(ScreenSubscription, {})
                                                                                                        : screen === '#/crm' ?
                                                                                                            () => _jsx(ScreenCRMHub, {})
                                                                                                            : screen === '#/crm/conversations' ?
                                                                                                                () => _jsx(ScreenCRMConversations, {})
                                                                                                                : screen.startsWith('#/crm/conversations/') ?
                                                                                                                    () => _jsx(ScreenCRMConversations, { initialConversationId: screen.substring('#/crm/conversations/'.length) })
                                                                                                                    : screen === '#/crm/scheduling' ?
                                                                                                                        () => _jsx(ScreenCRMScheduling, {})
                                                                                                                        : screen === '#/crm/email-campaigns' ?
                                                                                                                            () => _jsx(ScreenCRMEmailCampaigns, {})
                                                                                                                            : SCREEN_IS_HOME ?
                                                                                                                                () => _jsx(ScreenDashboard, { token: token })
                                                                                                                                : undefined;
    if (screen.startsWith('#/inspection-mode') && !!token) {
        const path = screen.substring('#/inspection-mode'.length);
        const parts = path.split('/').filter((x) => x !== '');
        const exitToPin = () => { setActivePerformer(null); navigate('#/inspection-mode/pin'); };
        if (parts.length === 0 || parts[0] === 'pin' || !activePerformer) {
            return _jsx(ScreenInspectionPin, { onAuthenticated: (id, name) => { setActivePerformer({ 'id': id, 'name': name }); } });
        }
        if (parts[0] === 'my-jobs') {
            return _jsx(ScreenInspectionMyJobs, { performerName: activePerformer.name, performerId: activePerformer.id, onExitToPin: exitToPin });
        }
        if (parts[0] === 'new') {
            return _jsx(ScreenInspectionNew, { performerId: activePerformer.id, invoiceId: parts[1], onExit: exitToPin });
        }
        if (parts.length === 1) {
            return _jsx(ScreenInspectionSectionList, { inspectionId: parts[0], onExit: exitToPin });
        }
        if (parts.length === 2 && parts[1] === 'review') {
            return _jsx(ScreenInspectionReview, { inspectionId: parts[0], onExit: exitToPin });
        }
        if (parts.length === 2) {
            return _jsx(ScreenInspectionSection, { inspectionId: parts[0], sectionName: decodeURIComponent(parts[1]), performerId: activePerformer.id, onExit: exitToPin });
        }
        return _jsx(ScreenInspectionPin, { onAuthenticated: (id, name) => { setActivePerformer({ 'id': id, 'name': name }); } });
    }
    if (inKiosk && !screen.startsWith('#/inspection-mode')) {
        return null;
    }
    return _jsxs(_Fragment, { children: [_jsx(CModal, { visible: !!modals.changes.href, title: "Unsaved Changes", onClose: () => modalsUpdate.changes.href(null), onSubmit: () => { navigate(modals.changes.href); modalsUpdate.changes.href(null); }, footer: () => _jsx(Button, { submit: true, color: "danger", children: "Continue Without Saving" }), children: "Unsaved changes will be lost." }), screen.startsWith('#/onboarding')
                ? _jsx(_Fragment, { children: _jsx("div", { style: {
                            'display': 'flex',
                            'flexDirection': 'column',
                            'margin': 'auto',
                            'maxWidth': '1586px',
                            'width': '100%',
                            'marginTop': '1em',
                            'marginBottom': '1em'
                        }, children: _jsx(ScreenOnboarding, {}) }) })
                : screen.startsWith('#/login') || !token
                    ? _jsx(_Fragment, { children: _jsxs("div", { style: {
                                'display': 'flex',
                                'flexDirection': 'column',
                                'margin': 'auto',
                                'maxWidth': '1586px',
                                'width': '100%',
                                'marginTop': '1em',
                                'marginBottom': !!token && !euaAccepted ? '100px' : ''
                            }, children: [_jsx(ScreenLogin, { onLogin: login }), " "] }) })
                    :
                        _jsx(TemplateMain, { navigate: navigateCheckSave, screen: screen, title: pageTitle, onLogout: () => {
                                clearSubscriptionCache();
                                setToken(null);
                                navigate('#/login');
                            }, invoiceClassification: invoiceClassification, children: content ? content() : null }), !!token && !euaAccepted &&
                _jsx("div", { className: "position-fixed left-0 w-100", style: { 'bottom': '1rem' }, children: _jsxs("div", { className: "d-flex alert alert-danger mx-3 justify-content-center align-items-center", role: "alert", children: [_jsxs("span", { children: ["By utilizing this application you agree to the ", _jsx("a", { href: "#/end-user-agreement", children: "End User Agreement found here." })] }), _jsx(Button, { color: "primary", onClick: euaAccept, ms: 5, children: "I Understand" })] }) })] });
};
